import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { objectGroup } from 'app/models/objectGroup.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';


@Injectable({ providedIn: 'root' })
export class ObjectGroupService {
  private apiUrl = `${environment.baseUrl}/objectgroup`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }

  getobjectGroupList(): Observable<any> {
    return this.commonAPI.getApiCall(`${this.apiUrl}/getAllobjectGroups`);
    // return this.http.get(`${this.apiUrl}/getAllobjectGroups`);
  }

  getobjectGroupWithSC(shortcode: string): Observable<any> {
    // debugger;
    console.log(`${this.apiUrl}/getobjectGroupWithSC/${shortcode}`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getobjectGroupWithSC/${shortcode}`);
    // return this.http.get(`${this.apiUrl}/getobjectGroupWithSC/${shortcode}`);
  }

  getobjectGroupLinesByShortCode(shortcode: string): Observable<any> {
    console.log(`${this.apiUrl}/getobjectGroupLinesByShortCode/${shortcode}`);
    // let aaa = this.http.get(`${this.apiUrl}/getobjectGroupLinesByShortCode/${shortcode}`);
    // console.log(aaa);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getobjectGroupLinesByShortCode/${shortcode}`);
    // return this.http.get(`${this.apiUrl}/getobjectGroupLinesByShortCode/${shortcode}`);
  }

  saveobjectGroup(objectGroup: any): Observable<any> {
    console.log(objectGroup);
    //OGshortcode, OGName, OGRemarks, ObjectGroupLinesArr
    //objGroupShortcode, objGroupName, objGroupRemarks, details,

      const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
        "objGroupShortcode": objectGroup.objGroupShortcode ?? objectGroup.OGshortcode,
        "objGroupName": objectGroup.objGroupName ?? objectGroup.OGName,
        "objGroupRemarks": objectGroup.objGroupRemarks ?? objectGroup.OGRemarks,
        "objGroupGroupColorFlag": objectGroup.objGroupGroupColorFlag ?? '',
        "objGroupXpos": objectGroup.objGroupXpos ?? null,
        "objGroupYpos": objectGroup.objGroupYpos ?? null,
        "objGroupWidth": objectGroup.objGroupWidth ?? null,
        "objGroupHeight": objectGroup.objGroupHeight ?? null,
        "objGroupOverlapFlag": objectGroup.objGroupOverlapFlag ?? '',
        "objGroupFixedSizeFlag": objectGroup.objGroupFixedSizeFlag ?? '',
        "objGroupContentAlign": objectGroup.objGroupContentAlign || 'LEFT-TOP',
        "objGroupMaxRows": objectGroup.objGroupMaxRows ?? null,
        "objGroupMaxCols": objectGroup.objGroupMaxCols ?? null,
        "objGroupRowReverseFlag": objectGroup.objGroupRowReverseFlag ?? '',
        "objGroupGroupTraverseFlag": objectGroup.objGroupGroupTraverseFlag ?? '',
        "objGroupAlternateSkewFlag": objectGroup.objGroupAlternateSkewFlag ?? '',
        "objGroupCircleFlag": objectGroup.objGroupCircleFlag ?? '',
        "objGroupCircleRadius": objectGroup.objGroupCircleRadius ?? null,
        "objGroupCircleAngleStart": objectGroup.objGroupCircleAngleStart ?? null,
        "objGroupCircleAngleEnd": objectGroup.objGroupCircleAngleEnd ?? null,
        "objGroupCircleFullFlag": objectGroup.objGroupCircleFullFlag ?? '',
        "objGroupCircleRotateFlag": objectGroup.objGroupCircleRotateFlag ?? '',
        "objGroupCircleRadiusSkew": objectGroup.objGroupCircleRadiusSkew ?? null,
        "details": objectGroup.details ?? objectGroup.ObjectGroupLinesArr,
        tenant: null
      }
    };

    let aaa= this.commonAPI.postApiCall(`${this.apiUrl}/saveObjectGroup`, body);
    console.log(aaa);
    return aaa;

    // return this.http.post(`${this.apiUrl}/saveObjectGroup`, objectGroup);
  }

  getObjectGroupMasterCodes(filtername: string): Observable<any> {
    console.log(`${this.apiUrl}/getObjectGroupMasterCodes/${filtername}`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getObjectGroupMasterCodes/${filtername}`);
    // return this.http.get(`${this.apiUrl}/getObjectGroupMasterCodes/${filtername}`);
  }

  deleteObjectGroup(shortcode: string): Observable<any> {

const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
        "objGroupShortcode":shortcode, 
               tenant: null
      }
    };

    let aaa= this.commonAPI.postApiCall(`${this.apiUrl}/deleteObjectGroup`, body);
    console.log(aaa);
    return aaa;

    // return this.http.delete(`${this.apiUrl}/deleteObjectGroup/${shortcode}`);
  }
}
